import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-manual-check',
  templateUrl: './manual-check.component.html',
  styleUrls: ['./manual-check.component.scss']
})
export class ManualCheckComponent implements OnInit {

  manualCheck = this.fb.group({
    date: [new Date().toISOString().split('T')[0], Validators.required],
    notes: null
  }, {});

  constructor(
    private fb: UntypedFormBuilder,
    public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  onConfirm() {
    if (this.manualCheck.valid) {
      this.activeModal.close(this.manualCheck.value);
    }
  }

  onDateChange(newDate: any) {
    this.manualCheck.controls['date'].setValue(newDate);
  }

  close() {
    this.activeModal.dismiss();
  }

}
